import { X, IndianRupee, Calendar, CreditCard, FileText } from "lucide-react"
import Button from '../../common/Button.js'
import { useTranslation } from 'react-i18next';
import { formatAuditUser } from '../../../utils/userDisplay'


const ViewPaymentModal = ({ payment, onClose }) => {
  if (!payment) return null

  const fmt = (v) =>
    parseFloat(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  const Row = ({ label, value, valueClass = "text-secondary" }) => (
    <div className="flex justify-between items-start py-2 border-b border-dashed border-gray-100 last:border-0">
      <span className="text-xs text-gray-500 font-medium">{label}</span>
      <span className={`text-xs font-semibold text-right max-w-[60%] ${valueClass}`}>{value || "—"}</span>
    </div>
  )

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <IndianRupee className="w-4 h-4 text-orange-500" />
            <h2 className="font-bold text-secondary text-base">Payment Details</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Amount Hero */}
        <div className="bg-orange-50 border-b border-orange-100 px-5 py-4 text-center">
          <div className="text-xs text-orange-600 font-semibold mb-1">{payment.payment_id}</div>
          <div className="text-3xl font-bold text-orange-600">₹{fmt(payment.amount)}</div>
          {payment.payment_mode && (
            <div className="mt-1 inline-flex items-center gap-1 text-xs text-orange-500 font-medium">
              <CreditCard className="w-3 h-3" /> {payment.payment_mode}
            </div>
          )}
        </div>

        {/* Details */}
        <div className="px-5 py-3">
          <Row label="Payment Date" value={payment.payment_date} />
          <Row label="Reference / Cheque No." value={payment.reference_number} />
          <Row label="Remarks" value={payment.remarks} />
          <Row label="Created By" value={formatAuditUser(payment, 'created_by')} />
          <Row
            label="Created At"
            value={payment.created_at ? new Date(payment.created_at).toLocaleDateString("en-IN") : "—"}
          />
          {payment.has_receipt && (
            <div className="flex justify-between items-center py-2 border-b border-dashed border-gray-100">
              <span className="text-xs text-gray-500 font-medium">Receipt</span>
              <a href={payment.receipt_url} target="_blank" rel="noreferrer"
                className="text-xs font-semibold text-orange-500 underline">
                View Receipt
              </a>
            </div>
          )}
          {(payment.updated_by || payment.updated_by_display) && (
            <>
              <Row label="Updated By" value={formatAuditUser(payment, 'updated_by')} />
              <Row
                label="Updated At"
                value={payment.updated_at ? new Date(payment.updated_at).toLocaleDateString("en-IN") : "—"}
              />
            </>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t border-gray-100 flex justify-end">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ViewPaymentModal